(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('RankAddonController', RankAddonController);

        RankAddonController.$inject = ['$state', 'History'];

    function RankAddonController($state, History) {
        var vm = this;
        vm.credits;
        init();
        function init(){
            loadCreditsHistory();
        }

        function loadCreditsHistory() {
            History.myCredits({}, function (response) {
                if (response.credits){
                    vm.creditsLastMonth = response.credits[response.credits.length - 1];
                    vm.credits = response;
                }
            });
        }
    }
})();
